import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]


import { ProjectSide } from '@/libs/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSideArea',
  props: {
    list: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
    return (_openBlock(), _createElementBlock("a", {
      key: index,
      class: _normalizeClass(["flex projectSide md:h-10 h-5 justify-end", item.styleOpacity ? item.styleOpacity : '']),
      href: item.href,
      target: "_blank"
    }, [
      _createElementVNode("img", {
        src: require(`@/images/${item.logo_src}${item.logo_src === 'arconnect' ? '.svg' : '.png'}`),
        class: _normalizeClass(["h-full transition-opacity", item.imgOpacity ? item.imgOpacity : '']),
        alt: item.logo_src
      }, null, 10, _hoisted_2)
    ], 10, _hoisted_1))
  }), 128))
}
}

})